import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { ITransactionMutationResponse } from 'core/types/models/transferPreviewType';
import { useDispatch } from 'react-redux';

export const useChangeWalletAmountMutation = (callBack?: () => void) => {
	const queryClient = useQueryClient();
	const dispatch = useDispatch();

	return useMutationHook(
		[endPointUrls.ADMIN_CHANGE_WALLET_BALANCE],
		(data) => api.post(endPointUrls.ADMIN_CHANGE_WALLET_BALANCE, data),
		{
			onSuccess: (res: any) => {
				queryClient.invalidateQueries([endPointUrls.WALLETS]);
				if (res?.status === 200) {
					callBack?.();
					toastHandler('success', res?.data.message);
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult<any>;
};
